import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Capacitor } from '@capacitor/core';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import store from './store/store';
import { NotificationProvider } from './context/NotificationContext';

// Set global flag for iframes to detect native environment
window.isNativeApp = Capacitor.isNativePlatform();

const root = createRoot(document.getElementById('root'));
const originalConsoleLog = console.log;
console.log =
  process.env.NODE_ENV === 'production' ? () => {} : originalConsoleLog;

root.render(
  <Provider store={store}>
    <NotificationProvider>
      <App />
    </NotificationProvider>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
